import * as React from "react";
const SvgFiRrVolleyball = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-volleyball_svg__a)">
      <path
        fill="#062147"
        d="M12.003-.002C5.365-.002-.016 5.379-.016 12.017c0 6.637 5.381 12.018 12.019 12.018s12.019-5.38 12.019-12.018S18.64-.002 12.002-.002M21.875 10.5v.003a10 10 0 0 1-2.938 1.231 18.2 18.2 0 0 0-3.07-8.954 10.02 10.02 0 0 1 6.008 7.72M12 2c.253 0 .5.02.749.038a16.23 16.23 0 0 1 4.2 9.95 10 10 0 0 1-4-.69 12.03 12.03 0 0 0-4.45-8.652A9.9 9.9 0 0 1 12 2M6.487 3.665c.94.613 1.769 1.379 2.455 2.266a18.25 18.25 0 0 0-6.708 8.2A9.96 9.96 0 0 1 6.487 3.665m-3.131 13.34a16.26 16.26 0 0 1 6.62-9.355c.592 1.216.93 2.54.993 3.891a12.03 12.03 0 0 0-4.715 8.63 10.06 10.06 0 0 1-2.898-3.166M12 22a9.95 9.95 0 0 1-3.772-.744 10 10 0 0 1 .672-3.775 17.9 17.9 0 0 0 10.475 1.25A9.96 9.96 0 0 1 12 22m-2.2-6.31a10 10 0 0 1 2.369-2.55c1.413.572 2.923.868 4.448.873a12.1 12.1 0 0 0 5.348-1.25 9.9 9.9 0 0 1-.943 3.522A16.26 16.26 0 0 1 9.8 15.69"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-volleyball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVolleyball;
